import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SigninComponent } from './signin/signin.component';

const authRoutes: Routes = [
  { path: 'login', component: SigninComponent },
  { path: 'login-by-hash', component: SigninComponent, data: { section: 'login-by-hash' } },
];

@NgModule({
  imports: [
    RouterModule.forChild(authRoutes)
  ],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
